import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';

export const Container = styled.div`
    display: flex;
    width: max-content;
    height: max-content;
`;

export const Button = styled.button`
    padding: 9px 18px;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};
    border: 2px solid transparent;
    border-radius: 999px;
    z-index: 0;
    background-color: #F2F2F2;
    display: block;
    cursor: pointer;
    transition: all .15s ease-in-out;

    &:hover {
        background-color: #D9D9D6;
    }

    &:last-of-type {
        padding-left: 46px;
        margin-left: -38px;
    }

    &:first-of-type {
        padding-right: 46px;
    }

    &:focus {
        outline: none;
        border-color: ${colors.BLACK};
    }

    &:disabled {
        background-color: ${({ isSelected }) => (isSelected ? colors.WHITE : colors.GREY_LIGHT)};
        border-color: ${({ isSelected }) => (isSelected ? colors.BRAND_ORANGE : 'transparent')};
        color: ${({ isSelected }) => (isSelected ? colors.BLACK : colors.GREY_MEDIUM)};
        z-index: ${({ isSelected }) => (isSelected ? 1 : 0)};
        cursor: default;

        &:first-of-type {
            padding: ${({ isSelected }) => (isSelected ? '9px 18px' : '9px 46px 9px 18px')};
        }

        &:last-of-type {
            padding: ${({ isSelected }) => (isSelected ? '9px 18px' : '9px 18px 9px 46px')};
        }
    }
`;
